import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button } from "antd";
import {
  Row,
  Form,
  Input,
  Col,
  Select,
  Collapse,
  notification,
  Popconfirm,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import jsPDF from 'jspdf';
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

import {
  MinusCircleTwoTone,
  PlusCircleTwoTone,
  DeleteOutlined,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import AllergensApi from "../../common/Apis/AllergensApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
const Allergens = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Allergens, setAllergens] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));



  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [formPaginate] = Form.useForm();
  const [totalElements, setTotalElements] = useState(0);

  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    AllergensApi.ListAllergensApi(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setAllergens(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    AllergensApi.ListAllergensApi(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setAllergens(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };


  const getAllergens = useCallback(() => {
    AllergensApi.ListAllergensApi(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setAllergens(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getAllergens();
    PageLoading();
  }, []);


  function formatDate(date) {
    const dateNew = parseInt(date, 10);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(dateNew).toLocaleDateString(
      "en-US",
      options
    );

    const [month, day, year] = formattedDate.split(" ");
    const capitalizedMonth = month.toUpperCase();
    return `${day} ${capitalizedMonth} ${year}`;
  }

  const handlePrintButtonClick2 = () => {
    const fontSize = 12;
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [210, 297], // A4 size
    });

    let yPos = 35;
    doc.setFontSize(fontSize);

    const currentDate = new Date().toLocaleDateString();
    const currentTime = new Date().toLocaleTimeString();
    const promises = [];

    for (let i = 0; i < parseInt(PaginatetotalPages); i++) {
      promises.push(
        AllergensApi.ListAllergensApi(i, PaginateLimit).then((response) => {
          doc.setFont('Poppins', 'bold');
          doc.text(`Allergens`, 105, 10, { align: 'center' });
          doc.setFont('Poppins', 'normal');
          doc.setFontSize(10);
          doc.text(`Date : ${currentDate}`, 10, 20);
          doc.text(`Time : ${currentTime}`, 10, 25);
          doc.setFontSize(fontSize);

          // Draw table headers and borders
          doc.setFont('Poppins', 'bold');
          doc.text('Date', 15, yPos);
          doc.text('Allergens Name', 125, yPos);
          doc.setFont('Poppins', 'normal');
          doc.setLineWidth(0.1);
          doc.rect(12, yPos - 5, 190, 10);
          yPos += 10;

          response.payloadDto.forEach(row => {
            const date = formatDate(row?.createdDate);
            const allergenInfo = row?.allergensName;

            doc.setFontSize(fontSize);

            doc.text(date, 15, yPos);
            const allergenLines = doc.splitTextToSize(allergenInfo, 40);
            doc.text(allergenLines, 125, yPos);

            const rowHeight = 10 * Math.max(allergenLines.length, 1);

            if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
              doc.addPage();
              yPos = 35; // Reset yPos for the new page
            } else {
              doc.setLineWidth(0.1);
              doc.rect(12, yPos - 5, 190, rowHeight);
              yPos += rowHeight;
            }
          });

          if (i === parseInt(PaginatetotalPages)) {
            doc.addPage();
            yPos = 35;
          }
        }).catch((err) => {
          console.log(err);
        })
      );
    }

    const reversedPromises = promises.map(promise =>
      promise.then(result =>
        new Promise(resolve =>
          setTimeout(() => resolve(result), 0)
        )
      )
    );

    Promise.all(reversedPromises)
      .then(() => {
        window.open(doc.output('bloburl'), '_blank');
      })
      .catch((err) => {
        console.log(err);
      });

  };



  const handleDeleteAllergens = (AllergensID) => {
    AllergensApi.DeleteAllergensApi(AllergensID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getAllergens();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };
  const handleRemovefilterallergens = (FiltergetAllergensIndex) => {
    const newfilterAllergen = [...filterAllergens];
    newfilterAllergen.splice(FiltergetAllergensIndex, 1);
    setFilterAllergens(newfilterAllergen);
    if (FiltergetAllergensIndex == 0) {
      getAllergens();
    }
  };
  const handleClear = () => {
    getAllergens();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterAllergens([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterAllergens, setFilterAllergens] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterAllergens = () => {
    setFilterAllergens([
      ...filterAllergens,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterAllergens
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=${obj.name}`;
        }
      })
      .join("&");

    let filderData = window.btoa("componentCode=ALLERGENS&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString);
    QuestionnairesApi.FilterQuestionset(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setAllergens(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };
  const handleChangeTitle = (FiltergetAllergensIndex, value) => {
    const newfilterAllergen = [...filterAllergens];
    newfilterAllergen[FiltergetAllergensIndex].title = value;
    setFilterAllergens(newfilterAllergen);
  };
  const handleChangeAnswertype = (FiltergetAllergensIndex, value) => {
    const newfilterAllergen = [...filterAllergens];
    newfilterAllergen[FiltergetAllergensIndex].answerType = value;
    setFilterAllergens(newfilterAllergen);
  };

  const handleChangename = (FiltergetAllergensIndex, value) => {
    const newfilterAllergen = [...filterAllergens];
    newfilterAllergen[FiltergetAllergensIndex].name = value;
    setFilterAllergens(newfilterAllergen);
  };

  const paginatedData = Allergens;

  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">
          <td style={{ width: "15%" }} className="pt-3">
            {new Date(item.createdDate).toLocaleDateString()}
          </td>
          <td style={{ width: "30%" }} className="pt-3">
            {item?.allergensName}
          </td>

          <td style={{ width: "25%" }}>
            <div className="d-flex ">
              <Link
                to={`/masters/allergens/edit-allergens?id=${item?.id}`}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'EDIT_ALLERGENS'
                ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
              >
                <EditOutlined />
                Edit
              </Link>
              <Popconfirm
                title="Are you sure ?"
                description="Do you really want to delete this Allergens ?"
                okText="Yes"
                onConfirm={() => handleDeleteAllergens(item.id)}
                placement="topRight"
                className="w-100"
                cancelText="No"
              >
                <Link
                  to={``}
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'DELETE_ALLERGENS'
                  ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                >
                  <DeleteOutlined />
                  Delete
                </Link>
              </Popconfirm>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={3} className="text-center ">
            <EmptyBox />
            <br />
            {/* <Button
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'ADD_ALLERGENS'
              ) ? 'btn btn-primary btn-save m-0 my-4' : 'd-none'}
              href={"/masters/allergens/add-allergens"}
            >
              Add Allergens
            </Button> */}
            <Button
              type="primary"
              onClick={() => navigate("/masters/allergens/add-allergens")}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_ALLERGENS'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add Allergens
            </Button>
          </td>
        </tr>
      );
    }
  };


  const [modalAddVisible, setModalAddVisible] = useState(false);

  const handleOpenAddModal = () => {
    setModalAddVisible(true);
  };
  const handleAddCloseModal = () => {
    setModalAddVisible(false);
  };

  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [modalEditData, setModalEditData] = useState("");

  const handleOpenEditModal = (AllergensID) => {
    AllergensApi.SingleAllergensApi(AllergensID)
      .then((response) => {
        console.log(response);
        setModalEditData(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });
    setModalEditVisible(true);
  };
  const handlEditeCloseModal = () => {
    setModalEditVisible(false);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader onPrintResponse2={handlePrintButtonClick2} />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterAllergens.map((input, filterallergensIndex) => (
                    <div key={filterallergensIndex}>
                      <Row gutter={12} className="pt-2">
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterallergensIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterallergensIndex, value)
                              }
                              options={[
                                {
                                  value: "allergensName",
                                  label: "Allergens Name",
                                },
                                {
                                  value: "institution.institutionName",
                                  label: "Department",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={4}>
                          <Form.Item
                            name={`type${filterallergensIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select type.",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select mb-1"
                              placeholder="Condition"
                              onChange={(value) =>
                                handleChangeAnswertype(
                                  filterallergensIndex,
                                  value
                                )
                              }
                              options={[
                                { value: "%", label: "Matches with" },
                                {
                                  value: "=",
                                  label: "Equals to",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={5}>
                          <Form.Item
                            name={`name${filterallergensIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please enter Text.",
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              onChange={(e) =>
                                handleChangename(
                                  filterallergensIndex,
                                  e.target.value
                                )
                              }
                              placeholder="Text"
                              className="control-input"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterallergensIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterAllergens}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterallergens(
                                      filterallergensIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>

            <div className="d-flex justify-content-between align-items-center">
              <div>
                {paginatedData.length > 0 && (
                  <Button
                    type="primary"
                    onClick={() => navigate("/masters/allergens/add-allergens")}
                    style={{
                      display: decodedToken?.permissions?.some(
                        permission => permission?.authority === 'ADD_ALLERGENS'
                      ) ? '' : 'none',
                      height: 'auto',
                      lineHeight: 'normal',
                      alignItems: 'center',
                      padding: '5px 24px',
                    }}
                  >
                    Add Allergens
                  </Button>
                )}
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Allergens Name</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>

        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Allergens;
